module.exports = __webpack_public_path__ + "static/media/Sedimento-Cinza.a68788e8.svg";